import { createContext } from 'react';

import type { ApiError } from '@/util';

export type ApiContextProps = {
  error?: Nullish<ApiError<any, any>>;
};

const ApiContext = createContext<ApiContextProps>({});

export default ApiContext;
